import utils from 'utils';
'use strict';

class RegionsAutocomplete {
  constructor(elem, searchItems) {
    this.apiUrl = '/api/search/destinations';
    this.apiFetchParameters = {
      method: 'GET',
      cache: 'default',
    };
    this.elem = elem;
    // this.resetButton = this.elem.querySelector('.regions-autocomplete-reset');
    this.input = this.elem.querySelector('.regions-autocomplete-input');
    this.resortIdsInput = document.getElementById('search-resorts');
    this.buttonSearch = document.getElementById('edit-submit');
    this.buttonMap = document.getElementById('edit-map');
    this.errorsField = document.querySelector('.edit-errors');
    this.typeValue = (document.querySelector('.search-engine-type')?.querySelector('.switch-option.active')?.dataset.value) || '';
    this.minChars = 3;
    this.cachedResults = {};
    this.labels = JSON.parse(this.elem.dataset.labels);
    this.isMobile = utils.mq.sm.matches;
    this.isMultiple = this.elem.dataset.isMultiple;
    // if (this.isMultiple) { this.input.readOnly = 'readonly'; }
    this.searchItems = searchItems;
    if(this.searchItems == null || this.searchItems == undefined) {
      this.searchItems = [];
    }
    if(this.input.hasAttribute('data-default')) {
      let searchItemsArray = sessionStorage.getItem('searchItems');
      if(searchItemsArray && searchItemsArray.length > 0) {
        this.searchItems = [];
        sessionStorage.removeItem('searchItems');
      }
      const defaultValue = this.input.getAttribute('data-default');
      let cleanDefaultValue = defaultValue.replace(/^"|"$/g, '');
      this.input.value = '';
      this.input.placeholder = '';
      this.searchItems.push(cleanDefaultValue);
      sessionStorage.setItem('searchItems', JSON.stringify(this.searchItems));
    }

    if(this.searchItems.length > 0) {
      this.input.placeholder = '';
      this.input.focus();
      this.handleSelectMultipleInputItemsContainer(this.searchItems);
    } else {
      this.input.placeholder = this.labels.all;
    }
    this.events();
  }

  isLoading() {
    let loader = document.createElement('div');
    loader.classList.add('loader', 'regions-autocomplete-loader', 'p-a', 't-100', 'zi-1011@<md', 'zi-5', 'd-f', 'w-100', 'mt-xxs', 'pbl-xl', 'pin-m', 'ai-c', 'jc-c', 'brad-s', 'c-darkest', 'bgc-lightest');
    loader.innerHTML = "<div class='loader-spinner brad-50'></div>";

    this.elem.append(loader);
  }

  resetInput() {
    this.input.value = '';
    this.resortIdsInput.value = '';
    this.searchItems = [];
  }

  allDestinations() {
    this.input.value = '';
    this.resortIdsInput.value = '';
    this.searchItems = [];
    this.searchAll();
    sessionStorage.removeItem('searchItems');
  }

  getApiUrlWithParameters(query) {
    let typeValue = (document.querySelector('.search-engine-type')?.querySelector('.switch-option.active')?.dataset.value) || '';
    let params = new URLSearchParams();
    if (query !== '') {
      params.append('q', query);
    }
    if (typeValue !== '') {
      params.append('type', typeValue);
    }
    return `${this.apiUrl}?${params.toString()}`;
  }

  getData(query, callback) {
    const apiURl = this.getApiUrlWithParameters(query);
    fetch(apiURl)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        callback(json);
      });
  }

  events() {

    utils.mq.sm.addListener(e => this.isMobile = e.matches);

    if (this.input) {
      if (!this.isMultiple) {
        this.input.addEventListener('keyup', utils.debounce(e => {
          this.searchSingle(e);
        }, 250));

      } else {
        this.input.addEventListener('mouseover', () => {
          this.input.title = this.input.value;
        });
      }

      this.input.addEventListener('keydown', utils.debounce(e => {
        if (this.input.value.length === 0 && this.searchItems.length === 0) {
          this.input.style.borderColor = '#dde1e3';
          this.input.style.borderWidth = '1px';
          this.input.style.borderStyle = 'solid';
          this.resortIdsInput.value = '';
          this.searchItems = [];
        }

        this.searchSingle(e);

      }, 250));

      this.input.addEventListener('focus', e => {
        // this.searchAll();
        if (this.isMobile) {
          if(document.querySelector('.labels-items-container')) {
            const labelsContainerWidth = document.querySelector('.labels-items-container').offsetWidth;
            this.input.style.cssText =
            `padding-left: ${labelsContainerWidth + 35}px;
             margin-right: 8px;
            `;
          }
        }
      });

      this.input.addEventListener('keyup', e =>{
        if (this.searchItems.length === 0
          && (this.input.value.length > 0 && this.resortIdsInput.value.trim().length === 0)) {
        // disabling the buttons map + search
        this.buttonSearch.disabled = true;
        this.buttonSearch.style.backgroundColor = '#e6007f9c';
        if (this.buttonMap !== null){
          this.buttonMap.disabled = true;
        }
      } else {
        this.buttonSearch.disabled = false;
        this.buttonSearch.style.backgroundColor = '#e6007f';
        if (this.buttonMap !== null){
          this.buttonMap.disabled = false;
        }

      }
      this.hideResult();
      });

      document.documentElement.addEventListener('click', e => {
        if (this.searchItems.length === 0
            && (this.input.value.length > 0 && this.resortIdsInput.value.trim().length === 0)) {
          this.input.style.borderColor = 'red';
          this.input.style.borderWidth = '1px';
          this.input.style.borderStyle = 'solid';
          // disabling the buttons map + search
          this.buttonSearch.disabled = true;
          this.buttonSearch.style.backgroundColor = '#e6007f9c';
          if (this.buttonMap !== null){
            this.buttonMap.disabled = true;
          }

          this.errorsField.classList.add('error-visible');
          this.errorsField.classList.remove('error-hidden');

          } else {
          // Optionnellement, cache le message d'erreur si la condition n'est pas remplie
          this.errorsField.classList.add('error-hidden');
          this.errorsField.classList.remove('error-visible');

          this.buttonSearch.disabled = false;
          this.buttonSearch.style.backgroundColor = '#e6007f';
          if (this.buttonMap !== null){
            this.buttonMap.disabled = false;
          }
        }
        this.hideResult();
      });

      // Element click corresponding to regions-autocomplete
      this.elem.addEventListener('click', e => {
        if(document.querySelector('.regions-autocomplete-result') === null) {
          this.searchAll();
        }
        e.stopPropagation();
      });
    }
  }

  search(query, lengthVal) {

    return new Promise((resolve, reject) => {

      this.hideResult();
      if (lengthVal <= 0 || lengthVal >= this.minChars) {

        this.isLoading();
        setTimeout(() => {

          if (this.cachedResults[query]) {
            this.displayResults(this.cachedResults[query]);
            resolve(this.cachedResults[query]); // Resolve the promise with cached results
          } else {
            this.getData(query, (data) => {
              let inputStripped = this.normalizeName(this.input.value);
              // autoselect the input value when it matches the data
                for (const region of data.regions){
                  this.compareAndAutoSelectItem(inputStripped, region.name, region.resortIds);

                  if (Array.isArray(region.villages)) {
                    for (const village of region.villages){
                    this.compareAndAutoSelectItem(inputStripped, village.name, village.resortId);
                  }
                }
                }
              this.cachingData(query, data);
              const displayed = this.displayResults(data);
              if (displayed) {
                document.querySelectorAll('.regions-autocomplete-item-btn').forEach(itemBtn => {
                    itemBtn.addEventListener('click', (event) => {
                      this.buttonSearch.disabled = false;
                      this.buttonSearch.style.backgroundColor = '#e6007f';
                      this.errorsField.classList.add('error-hidden');
                      this.errorsField.classList.remove('error-visible');
                      if (this.isMultiple) {
                        this.handleSelectMultipleItemClick(event.target);
                      } else {
                        this.handleSelectItemClick(event.target);
                      }
                      this.isMobile && this.input.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                    });
                });
                resolve(); // Resolve the promise after all operations are done
              } else {
                //reject('No data displayed or data already exist'); // Reject the promise if no data is displayed
                console.log('Error in promise');
              }
            });
          }
        }, 500);
      } else {
        //reject('Invalid length value'); // Reject the promise if the length value condition is not met
        console.log('Error in promise');
      }
    });
  }

  async searchSingle(e) {
    const input = e.target.value.split(',')[e.target.value.split(',').length - 1].trim().toLowerCase();
    const inputStripped = this.normalizeName(input); // Normalize the input to remove accents and special characters
    const inputWithoutPrefix = this.removePrefix(inputStripped); // Remove common prefixes

    try {
      // Perform search with and without prefix
      const searchResultsWithPrefix = await this.search(inputStripped, inputStripped.length);
      const searchResultsWithoutPrefix = await this.search(inputWithoutPrefix, inputWithoutPrefix.length);

      // Combine both sets of results and remove duplicates
      const combinedResults = this.combineResults(searchResultsWithPrefix, searchResultsWithoutPrefix);

      // Display the combined search results
      this.displayResults(combinedResults);
      } catch (error) {
          console.error('Error during search:', error);
      }
  }

  normalizeName(name) {
    return name.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  removePrefix(name) {
    // List of common prefixes in French and other languages
    const prefixes = ['le ', 'la ', 'les ', 'des ', 'du ', 'l\''];

    // Check if the name starts with any of these prefixes and remove it
    for (const prefix of prefixes) {
        if (name.startsWith(prefix)) {
            return name.substring(prefix.length);
        }
    }
    return name; // Return the name if no prefix is found
  }

  combineResults(resultsWithPrefix, resultsWithoutPrefix) {
     // Ensure both inputs are arrays
     if (!Array.isArray(resultsWithPrefix) || !Array.isArray(resultsWithoutPrefix)) {
      return [];
    }
    const resultSet = new Set([...resultsWithPrefix, ...resultsWithoutPrefix]);
    return Array.from(resultSet); // Convert back to an array to display
  }

  async searchAll() {
    await this.search('', 0);
  }


  compareAndAutoSelectItem(inputStripped, name, resortIds) {
    let nameStripped = name.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    let nameWithoutPrefix = nameStripped.replace(/^(le|la|les|de)\s+/i, '');
    let inputWithoutPrefix = inputStripped.replace(/^(le|la|les|de)\s+/i, '');

    if (inputStripped === nameStripped || inputStripped === nameWithoutPrefix || inputWithoutPrefix === nameStripped || inputWithoutPrefix === nameWithoutPrefix) {
        this.buttonSearch.disabled = false;
        this.buttonSearch.style.backgroundColor = '#e6007f';
        this.errorsField.classList.add('error-hidden');
        this.errorsField.classList.remove('error-visible');
        if (this.buttonMap !== null) {
            this.buttonMap.disabled = false;
        }
        if (this.isMultiple) {
            this.handleSelectMultipleItem(name, resortIds);
        } else {
            this.handleSelectItem(name, resortIds);
        }
    }
}
  handleSelectItemClick(item) {
    if (item.hasAttribute("data-name") && item.hasAttribute("data-resort-ids")) {
      const itemName = item.dataset.name;
      const itemResortIds = item.dataset.resortIds;
      this.handleSelectItem(itemName, itemResortIds);
    }
  }


  handleSelectItem(itemName, itemResortIds) {
    this.input.value = itemName;
    this.resortIdsInput.value = itemResortIds;

    var changeEvent = new Event('change');
    this.input.dispatchEvent(changeEvent);
    this.resortIdsInput.dispatchEvent(changeEvent);
    this.hideResult();
  }

  handleSelectMultipleItemClick(item) {

    if (item.hasAttribute("data-name") && item.hasAttribute("data-resort-ids")) {
      const itemName = item.dataset.name;
      const itemResortIds = item.dataset.resortIds;

      if (item.dataset.name === '' && item.dataset.resortIds === '') {
        this.allDestinations();
      }

      item.classList.toggle('bgc-main');
      // if closest li contains regions-autocomplete-item-region class toggle c-darker class on item
      item.closest('li').classList.contains('regions-autocomplete-item-region') && item.classList.toggle('c-darkest');
      item.classList.toggle('c-lightest');

      this.handleSelectMultipleItem(itemName, itemResortIds);
    }


  }

  handleSelectMultipleItem(itemName, itemResortIds) {

    if (this.searchItems.find((element) => element == itemName.trim()) === undefined){
      this.searchItems.push(itemName.trim());  //
      this.searchItems = this.searchItems.filter((element) => element !== "");
      this.resortIdsInput.value = this.resortIdsInput.value.length > 0 ? `${this.resortIdsInput.value},${itemResortIds}` : itemResortIds;
    } else {
      this.searchItems = [...new Set(this.searchItems)];
      this.searchItems.splice(this.searchItems.indexOf(itemName.trim()), 1);
      //this.input.value = this.input.value.replace(`${itemName}, `, '').replace(`, ${itemName}`, '').replace(`${itemName}`, '');
      this.resortIdsInput.value = this.resortIdsInput.value.replace(`${itemResortIds},`, '').replace(`,${itemResortIds}`, '').replace(`${itemResortIds}`, '');
    }

    var changeEvent = new Event('change');
    this.input.dispatchEvent(changeEvent);
    this.resortIdsInput.dispatchEvent(changeEvent);

    this.input.style.borderColor = '#dde1e3';
    this.input.style.borderWidth = '1px';
    this.input.style.borderStyle = 'solid';
    this.handleSelectMultipleInputItemsContainer(this.searchItems);

    if(this.searchItems.length > 0) {
      this.input.placeholder = '';
      sessionStorage.setItem('searchItems', JSON.stringify(this.searchItems));
    } else {
      this.searchAll();
      this.input.placeholder = this.labels.all;
      sessionStorage.removeItem('searchItems');
    }

    this.input.value = '';
    this.input.focus();
    }

  handleSelectMultipleInputItemsContainer(searchItems) {

    let parentDiv = document.querySelector('.regions-autocomplete');
    let labelsContainer;

    if (!document.querySelector('.labels-items-container')) {
      labelsContainer = document.createElement('div');
      labelsContainer.className = 'labels-items-container';
      let inputElement = parentDiv.querySelector('input');
      inputElement.parentNode.insertBefore(labelsContainer, inputElement.nextSibling);

      // Set styles for horizontal scrolling and hide the scrollbar
      labelsContainer.style.cssText =
        ` max-width: 200px;
          height: 51px;
          position: absolute;
          top: 0px;
          left: 35px;
          display: flex;
          align-items: center;
          overflow-x: auto;
          white-space: nowrap;
          padding: 0px 4px;
          border-radius: 8px;
          gap: 4px;
          justify-content: flex-end;
        `;
      labelsContainer.classList.add('hide-scrollbar');
    } else {
      labelsContainer = document.querySelector('.labels-items-container');
    }

    // Clears children element from container and renders again everytime an item is added or removed
    const labelsItemsContainer = document.querySelector('.labels-items-container');
    labelsItemsContainer.innerHTML = '';

    if(searchItems.length > 0) {

      searchItems.forEach( (element) => {
        const labelText = document.createElement('div');
        const closeIcon = document.createElement('span');
        labelText.className = 'label-item-text';
        labelText.textContent = element;
        labelText.style.cssText =
          ` white-space: nowrap;
            background-color: rgb(230, 0, 127);
            border-radius: 8px;
            color: rgb(255, 255, 255);
            padding: 4px 8px;
            font-size: 10px;
            display: flex;
            align-items: center;
            gap: 4px;
          `;
        labelText.appendChild(closeIcon);
        labelsContainer.appendChild(labelText);

        closeIcon.style.cssText =
          ` width: 12px;
            height: 12px;
            background-color: white;
            border-radius: 50%;
            color: rgb(230, 0, 127);
            font-size: 9px;
            padding: 0px 5px;
            border: 1px solid rgb(221, 225, 227);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          `;
        closeIcon.textContent = 'x';
        closeIcon.setAttribute('data-item-identifier', element);
        closeIcon.addEventListener('click', async function(event) {

          event.stopPropagation();
          await this.searchAll();

          // Trims any space on dom buttons elements
          const buttons = document.querySelectorAll('.regions-autocomplete-item-btn');
          buttons.forEach(button => {
            const dataName = button.getAttribute('data-name');
            if (dataName) {
                // Trim the data-name attribute and set it back
                button.setAttribute('data-name', dataName.trim());
            }
          });

          let itemName = event.target.getAttribute('data-item-identifier').trim();
          let matchingButton = document.querySelector(`button[data-name="${itemName}"]`);
          this.handleSelectMultipleItemClick(matchingButton);

        }.bind(this));
      });

      const labelsContainerWidth = document.querySelector('.labels-items-container').offsetWidth;
      this.input.style.cssText =
        `padding-left: ${labelsContainerWidth + 35}px;
         margin-right: 8px;
        `;
    } else {
      // if no elements selected remove all from dom
      labelsItemsContainer.remove();
      this.input.style.cssText =
        `padding-left: 2.5rem;
         margin-right: unset;
        `;
    }
  }

  addResultWrapper() {
    let resultParent = document.createElement('div');
    resultParent.classList.add('regions-autocomplete-result', 'p-a', 't-100', 'zi-1011@<md', 'zi-5', 'w-100', 'mt-xxs', 'brad-s', 'bgc-lightest');

    if (this.isMobile) {
      let resultParentCloseBtn = document.createElement('button');
      resultParentCloseBtn.classList.add('regions-autocomplete-result-close', 'p-a', 't-m', 'r-m', 'p-xxs', 'brad-50', 'c-darkest', 'ta-c', 'd-f', 'ai-c', 'jc-c', 'm-a', 'zi-1012@<md', 'zi-5');
      resultParentCloseBtn.innerHTML = '<span class="icon icon-close"></span>';
      resultParentCloseBtn.addEventListener('click', (event) => {
        //this.hideResult();
        event.stopPropagation();
        if (this.elem.querySelector('.regions-autocomplete-result')) {
          this.elem.querySelector('.regions-autocomplete-result').remove();
        }
      });
      resultParent.append(resultParentCloseBtn);
    }
    this.elem.append(resultParent);
    return resultParent;
  }

  addGrandRegionItem(grandregion) {

    if (grandregion !== 'all') {

      if (this.searchItems.find((element) => element == grandregion.name.trim()) === undefined){
        return `<li class="regions-autocomplete-item-gandregion mbl-xxs">
          <button type="button" data-name="${grandregion.name}" data-resort-ids="${grandregion.resortIds.join(',')}" class="regions-autocomplete-item-btn fs-xxxs p-xxxs ta-l brad-xs">${grandregion.name}</button>
        </li>`;
      } else {
        return `<li class="regions-autocomplete-item-gandregion mbl-xxs">
          <button type="button" data-name="${grandregion.name}" data-resort-ids="${grandregion.resortIds.join(',')}" class="regions-autocomplete-item-btn fs-xxxs p-xxxs ta-l brad-xs bgc-main c-lightest">${grandregion.name}</button>
        </li>`;
      }

    }

    return `<li class="regions-autocomplete-item-gandregion-all mt-xs mbl-xxxs">
      <button type="button" data-name="" data-resort-ids="" class="regions-autocomplete-item-btn fs-xxs fw-700 d-f p-xxxs ai-c tt-u c-darkest ta-l brad-xs">${this.labels.all} <span class="icon icon-arrow-right-main ml-xs"></span></button>
    </li>`;

  }

  addGrandRegionItems(resultWraper, grandRegions) {
    let resultGrandRegionsParent = document.createElement('div');
    grandRegions.length <= 0 && resultGrandRegionsParent.classList.add('regions-autocomplete-warning');
    grandRegions.length > 0 && resultGrandRegionsParent.classList.add('regions-autocomplete-result-grand-regions');
    resultGrandRegionsParent.classList.add('pt-xl', 'pb-m', 'pin-m', 'btlrad-s', 'btrrad-s');
    resultWraper.append(resultGrandRegionsParent);

    let listGrandRegions = document.createElement('ul');
    listGrandRegions.classList.add('regions-autocomplete-result-grand-regions-list');

    for (let grandRegion of grandRegions) {
      listGrandRegions.innerHTML += this.addGrandRegionItem(grandRegion);
    }

    listGrandRegions.innerHTML += this.addGrandRegionItem('all');
    resultGrandRegionsParent.append(listGrandRegions);
  }

  addRegionItem(region) {

    if (this.searchItems.find((element) => element == region.name.trim()) === undefined){
      return `<li class="regions-autocomplete-item-region d-f mbl-xs">
        <img class="regions-autocomplete-item-region-img" src="${region.icon}" />
        <div class="mt-xxxs ml-xs">
          <button type="button" data-name="${region.name}" data-resort-ids="${region.resortIds.join(',')}" class="regions-autocomplete-item-region-btn regions-autocomplete-item-btn fs-xxs fw-700 p-xxs tt-u c-darkest ta-l brad-xs">${region.name}</button>
          ${(typeof region.villages !== 'undefined' && region.villages.length > 0) ? this.addRegionVillages(region.villages) : ''}
        </div>
      </li>`;
    } else {
      return `<li class="regions-autocomplete-item-region d-f mbl-xs">
        <img class="regions-autocomplete-item-region-img" src="${region.icon}" />
        <div class="mt-xxxs ml-xs">
          <button type="button" data-name="${region.name}" data-resort-ids="${region.resortIds.join(',')}" class="regions-autocomplete-item-region-btn regions-autocomplete-item-btn fs-xxs fw-700 p-xxs tt-u ta-l brad-xs bgc-main c-lightest">${region.name}</button>
          ${(typeof region.villages !== 'undefined' && region.villages.length > 0) ? this.addRegionVillages(region.villages) : ''}
        </div>
      </li>`;
    }

  }

  addRegionVillages(villages) {
    let villagesItems = '';

    for (let village of villages) {
      villagesItems += this.addVillageItem(village);
    }

    return `
      <ul>
        ${villagesItems}
      </ul>
    `;
  }

  addVillageItem(village) {

    if (this.searchItems.find((element) => element == village.name.trim()) === undefined){
      return `<li class="regions-autocomplete-item-village fs-xxxs mbl-xxxs">
        <button type="button" data-name="${village.name}" data-resort-ids="${village.resortId}" class="regions-autocomplete-item-btn p-xxxs brad-xs">${village.name}</button>
      </li>`;
    } else {
      return `<li class="regions-autocomplete-item-village fs-xxxs mbl-xxxs">
        <button type="button" data-name="${village.name}" data-resort-ids="${village.resortId}" class="regions-autocomplete-item-btn p-xxxs brad-xs bgc-main c-lightest">${village.name}</button>
      </li>`;
    }

  }

  hideResult() {
    if (this.elem.querySelector('.regions-autocomplete-result')) {
      this.elem.querySelector('.regions-autocomplete-result').remove();
    }
  }

  cachingData(term, results) {
    if (results.length > 0) {
      this.cachedResults[term] = results;
    }
  }

  displayResults(results) {
    let displayed = false;
    if (this.elem.querySelector('.regions-autocomplete-loader')) {
      this.elem.querySelector('.regions-autocomplete-loader').remove();
    }

    const regionsAutocompleteResult = document.querySelector('.regions-autocomplete-result');

    if(!regionsAutocompleteResult) {

      const resultParent = this.addResultWrapper();
      if (Object.keys(results).length > 0) {
        // GRAND REGIONS
        if (typeof results.grandRegions !== 'undefined' && results.grandRegions.length > 0) {
          this.addGrandRegionItems(resultParent, results.grandRegions);

          displayed = true;
        }

        // REGIONS AND VILLAGES
        if (Object.keys(results.regions).length > 0) {
          let listRegions = document.createElement('ul');
          listRegions.classList.add('regions-autocomplete-region-list', 'pt-m', 'pb-s', 'pin-m', 'ox-h', 'oy-a', 'bblrad-s', 'bbrrad-s');

          for (let region of Object.values(results.regions)) {
            listRegions.innerHTML += this.addRegionItem(region);
          }

          resultParent.append(listRegions);

          displayed = true;
        }
      }

      if (!displayed && !this.elem.querySelector('.regions-autocomplete-warning')) {
        this.addGrandRegionItems(resultParent, []);
        // let warningElem = document.createElement('div');
        //   warningElem.classList.add('regions-autocomplete-warning', 'p-m');

        //   warningElem.innerHTML = `<li class="regions-autocomplete-item-gandregion-all mt-m">
        //   <button type="button" data-name="" data-resort-ids="" class="regions-autocomplete-item-btn fs-xxs fw-700 d-f ai-c tt-u c-darkest ta-l">All destinations <span class="icon icon-arrow-right-main ml-xs"></span></button>
        // </li>`;
        // resultParent.append(warningElem);
        displayed = true;
      }

    }

    return displayed;
  }
}

const autocompleteElem = document.querySelector('.regions-autocomplete');
if (autocompleteElem) {

  const resortIdsInput = document.getElementById('search-resorts');
  let savedSearchItems = [];

  if(resortIdsInput.value === ''){
    sessionStorage.removeItem('searchItems');
  }else{
    savedSearchItems = JSON.parse(sessionStorage.getItem('searchItems'));
  }

  autocompleteElem.autocomplete = new RegionsAutocomplete(autocompleteElem, savedSearchItems);

}
